/**
 * /phone with no code — type the six digits shown on the laptop.
 *
 * The QR path lands on /phone/:code directly, so this is the fallback for a
 * scanner that will not open the link, or for a student who typed the address
 * by hand.
 */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PhoneButton } from "./PhoneButton";

export function PairCodeEntry() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");

  const valid = /^\d{6}$/.test(code);

  return (
    <div className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center px-5 py-10">
      <h1 className="text-lg font-semibold text-ink">Connect your phone</h1>
      <p className="mt-1 text-sm text-ink-muted">
        Enter the six-digit code shown on your laptop.
      </p>

      <form
        className="mt-6 flex flex-col gap-3"
        onSubmit={(e) => {
          e.preventDefault();
          if (valid) navigate(`/phone/${code}`);
        }}
      >
        <label htmlFor="pair-code" className="text-xs font-medium text-ink-muted">
          Pairing code
        </label>
        <input
          id="pair-code"
          type="text"
          inputMode="numeric"
          autoComplete="one-time-code"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
          placeholder="000000"
          className="tabular min-h-11 w-full rounded-md border border-border-strong bg-surface px-3 text-xl tracking-[0.3em] text-ink placeholder:text-ink-faint"
        />

        <PhoneButton type="submit" disabled={!valid}>
          Connect
        </PhoneButton>
      </form>
    </div>
  );
}
